/* Type-to-filter for long facet value lists (e.g. Character / Person).
   A custom element so it re-wires itself automatically when the theme's
   facet-form AJAX swaps a group's content on each filter change
   (collection.js replaces .details__content innerHTML). Purely client-side:
   typing filters the already-rendered <li> values, it does not hit the server. */
if (!customElements.get('facet-search')) {
  customElements.define(
    'facet-search',
    class FacetSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.facet-search__input');
        this.empty = this.querySelector('.facet-search__empty');
        const content = this.closest('.details__content');
        this.list = content ? content.querySelector('.list') : null;
        if (!this.input || !this.list) return;

        this._onInput = () => this.filter();
        // Enter inside the facet-form would submit/navigate — suppress it.
        this._onKey = (e) => {
          if (e.key === 'Enter') e.preventDefault();
        };
        this.input.addEventListener('input', this._onInput);
        this.input.addEventListener('keydown', this._onKey);
      }

      disconnectedCallback() {
        if (!this.input) return;
        this.input.removeEventListener('input', this._onInput);
        this.input.removeEventListener('keydown', this._onKey);
      }

      filter() {
        const q = this.input.value.trim().toLowerCase();
        const items = this.list.children;
        let shown = 0;
        for (let i = 0; i < items.length; i++) {
          const li = items[i];
          const match = !q || li.textContent.toLowerCase().indexOf(q) !== -1;
          li.hidden = !match;
          if (match) shown += 1;
        }
        if (this.empty) this.empty.hidden = shown !== 0;
      }
    }
  );
}
